<template>
  <AddEditTemplate
    v-if="formData && !loading"
    :isEditMode="isEditMode"
    addEditType="DPE"
    :initialData="formData"
    :submitAction="submitForm"
  >
    <template #default="{ formData }">
      <AddEditFormGroup
        label="First Name"
        fieldId="firstName"
        v-model="formData.firstName"
        required
      />
      <AddEditFormGroup
        label="Last Name"
        fieldId="lastName"
        v-model="formData.lastName"
        required
      />
      <AddEditFormGroup
        label="Phone"
        fieldId="phone"
        v-model="formData.phone"
        type="tel"
      />
      <AddEditFormGroup
        label="Email"
        fieldId="email"
        v-model="formData.email"
        type="email"
        required
      />
      <AddEditFormGroup
        label="Preferred"
        fieldId="preferredId"
        v-model="formData.preferredId"
        component="select"
        :options="preferredOptions"
      />
      <AddEditFormGroup
        label="Preferred Method"
        fieldId="preferredMethodId"
        v-model="formData.preferredMethodId"
        component="select"
        :options="preferredMethodOptions"
      />
      <AddEditFormGroup
        label="Home Base"
        fieldId="homeBase"
        v-model="formData.homeBase"
      />
      <AddEditFormGroup
        label="Travel"
        fieldId="travelId"
        v-model="formData.travelId"
        component="select"
        :options="travelOptions"
      />
      <AddEditFormGroup
        label="PPL"
        fieldId="ppl"
        v-model="formData.ppl"
        type="number"
        step="any"
      />
      <AddEditFormGroup
        label="Instrument"
        fieldId="ir"
        v-model="formData.ir"
        type="number"
        step="any"
      />
      <AddEditFormGroup
        label="Commercial"
        fieldId="com"
        v-model="formData.com"
        type="number"
        step="any"
      />
      <AddEditFormGroup
        label="CFI - Initial"
        fieldId="cfiInitial"
        v-model="formData.cfiInitial"
        type="number"
        step="any"
      />
      <AddEditFormGroup
        label="CFII"
        fieldId="cfii"
        v-model="formData.cfii"
        type="number"
        step="any"
      />
      <AddEditFormGroup
        label="Com Multi"
        fieldId="comMulti"
        v-model="formData.comMulti"
        type="number"
        step="any"
      />
      <AddEditFormGroup
        label="MEI"
        fieldId="mei"
        v-model="formData.mei"
        type="number"
        step="any"
      />
      <AddEditFormGroup
        label="Weight"
        fieldId="weight"
        v-model="formData.weight"
        type="number"
      />
    </template>
  </AddEditTemplate>
</template>

<script>
import DpeAPIService from "src/servicehandlers/DpeAPIService.js";
import AddEditTemplate from "./AddEditTemplate.vue";
import AddEditFormGroup from "./AddEditFormGroup.vue";

const dpeAPIService = new DpeAPIService();

export default {
  components: { AddEditFormGroup, AddEditTemplate },
  data() {
    return {
      isEditMode: false,
      loading: true,
      formData: {
        firstName: "",
        lastName: "",
        dpePreferredMethod: "",
        phone: "",
        email: "",
        homeBase: "",
        travel: "",
        ppl: "",
        ir: "",
        com: "",
        cfiInitial: "",
        cfii: "",
        comMulti: "",
        mei: "",
        weight: "",
      },
      preferredOptions: [],
      preferredMethodOptions: [],
      travelOptions: [],
    };
  },
  async created() {
    if (this.$route.params.id) {
      this.isEditMode = true;
      await this.getDPE(this.$route.params.id);
    }
    await this.getPreferredOptions();
    await this.getPreferredMethodOptions();
    await this.getTravelOptions();
    this.loading = false;
  },
  methods: {
    async getDPE(id) {
      try {
        const response = await dpeAPIService.getById(id);
        this.formData = {
          ...response,
          firstName: response.user.firstName,
          lastName: response.user.lastName,
          phone: response.user.phone,
          email: response.user.email,
        };
      } catch (error) {}
    },
    async getPreferredOptions() {
      try {
        this.preferredOptions = await dpeAPIService.getPreferredOptions();
      } catch (error) {}
    },
    async getPreferredMethodOptions() {
      try {
        this.preferredMethodOptions =
          await dpeAPIService.getPreferredMethodOptions();
      } catch (error) {}
    },
    async getTravelOptions() {
      try {
        this.travelOptions = await dpeAPIService.getTravelOptions();
      } catch (error) {}
    },
    async submitForm(formData) {
      try {
        if (this.isEditMode) {
          await dpeAPIService.update(this.$route.params.id, formData);
        } else {
          await dpeAPIService.create(formData);
        }
      } catch (error) {}
    },
  },
};
</script>

<style scoped></style>
